import dayjs from 'dayjs';
import "dayjs/locale/ja"
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
// import isBetween from 'dayjs/plugin/isBetween' // ES 2015

dayjs.locale("ja");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.tz.setDefault("Asia/Tokyo");

export default dayjs;
